export enum BufferType {
    HEX = 'HEX',
    LARGE_BUFFER = 'LARGE_BUFFER',
    NUMBER = 'NUMBER',
    OBJECT = 'OBJECT',
    STRING = 'STRING',
}
